function Impressum() {
    return (
        <div className="d-flex justify-content-center">

            <div className="card" style={{width: '19rem', margin: '1rem'}}>
                <div className="card-body">
                    <h1 className="card-title">
                        <i className="bi bi-card-text"></i>
                    </h1>
                    <h3 className="card-title" style={{marginBottom: '1rem'}}>
                        Impressum
                    </h3>
                    <p>Prof. Dr. Jan-Peer Rudolph</p>
                    <p className="fw-bold">Hochschule Trier | Fachbereich Wirtschaft</p>
                    <p className="fw-bold">Trier University of Applied Sciences | Business School</p>
                    <p><i className="bi bi-geo"></i> Schneidershof | 54293 Trier</p>
                    <p><i className="bi bi-envelope"></i> jnrd0441(at)hochschule-trier.de</p>
                </div>
            </div>
        </div>
    );
}

export default Impressum;